/* istanbul ignore file */
var ThemeModes;
(function (ThemeModes) {
    ThemeModes["Light"] = "light";
    ThemeModes["Dark"] = "dark";
})(ThemeModes || (ThemeModes = {}));
export { ThemeModes };
//# sourceMappingURL=variables.js.map